@if (!mostrandoFormulario()) {
    <app-card-content [border]="false" [headerColor]="true" icon="pi pi-building" title="Conflito de Interesse">
        <div card-header>
            @if (abaSelecionada() === 'ATIVAS') {
                <app-botao-acoes [label]="'Ações'" [items]="acoesNovo" [appCan]="roleConflitoEditar" [appCanUf]="pessoa()?.uf" />
            }
        </div>

        <app-tab-container class="conflito-interesse-tab-switch" [options]="optionsTab" [(selected)]="abaSelecionada" (onChanged)="onToggleAba($event)" [useHeader]="false">
            <app-tab-content [value]="'ATIVAS'">
                <app-custom-table [metadata]="metadataTabela" [data]="empresasExibidasTabela()" [initialViewMode]="'table'" [showExpandButton]="false" [useCustomCard]="true" [cardColumns]="2">
                    <ng-template pTemplate="card" let-rowData>
                        <app-card-container [hoverEfect]="true" class="conflito-card-item cursor-pointer block h-full" (click)="abrirDialogRegistro(rowData)">
                            <div class="conflito-card-header">
                                <div class="conflito-card-title-row">
                                    <div class="conflito-card-status-badge">
                                        <p-tag [value]="rowData.situacao.value" [rounded]="true" [style]="{ 'background-color': rowData.situacao.color, color: '#ffffff' }"></p-tag>
                                    </div>
                                    <h3 class="conflito-card-title" [title]="rowData.razaoSocial">
                                        {{ obterRazaoSocialExibicao(rowData) }}
                                    </h3>
                                </div>
                            </div>

                            <div class="conflito-card-body">
                                @if (rowData.cnpj) {
                                    <div class="conflito-card-row">
                                        <i class="pi pi-id-card"></i>
                                        <span class="conflito-card-field-value">
                                            CNPJ: <span>{{ rowData.cnpj }}</span>
                                        </span>
                                    </div>
                                }

                                @if (rowData.dataInicio) {
                                    <div class="conflito-card-row">
                                        <i class="pi pi-calendar"></i>
                                        <span class="conflito-card-field-value">
                                            Data Início: <span>{{ rowData.dataInicio }}</span>
                                        </span>
                                    </div>
                                }

                                @if (rowData.dataFim) {
                                    <div class="conflito-card-row">
                                        <i class="pi pi-calendar"></i>
                                        <span class="conflito-card-field-value">
                                            Data Fim: <span>{{ rowData.dataFim }}</span>
                                        </span>
                                    </div>
                                }
                            </div>
                        </app-card-container>
                    </ng-template>
                </app-custom-table>
            </app-tab-content>

            <app-tab-content [value]="'INATIVAS'">
                <app-custom-table [metadata]="metadataTabela" [data]="empresasExibidasTabela()" [initialViewMode]="'table'" [showExpandButton]="false" [useCustomCard]="true" [cardColumns]="2">
                    <ng-template pTemplate="card" let-rowData>
                        <app-card-container [hoverEfect]="true" class="conflito-card-item cursor-pointer block h-full" (click)="abrirDialogRegistro(rowData)">
                            <div class="conflito-card-header">
                                <div class="conflito-card-title-row">
                                    <div class="conflito-card-status-badge">
                                        <p-tag [value]="rowData.situacao.value" [rounded]="true" [style]="{ 'background-color': rowData.situacao.color, color: '#ffffff' }"></p-tag>
                                    </div>
                                    <h3 class="conflito-card-title" [title]="rowData.razaoSocial">
                                        {{ obterRazaoSocialExibicao(rowData) }}
                                    </h3>
                                </div>
                            </div>

                            <div class="conflito-card-body">
                                @if (rowData.cnpj) {
                                    <div class="conflito-card-row">
                                        <i class="pi pi-id-card"></i>
                                        <span class="conflito-card-field-value">
                                            CNPJ: <span>{{ rowData.cnpj }}</span>
                                        </span>
                                    </div>
                                }

                                @if (rowData.dataInicio) {
                                    <div class="conflito-card-row">
                                        <i class="pi pi-calendar"></i>
                                        <span class="conflito-card-field-value">
                                            Data Início: <span>{{ rowData.dataInicio }}</span>
                                        </span>
                                    </div>
                                }

                                @if (rowData.dataFim) {
                                    <div class="conflito-card-row">
                                        <i class="pi pi-calendar"></i>
                                        <span class="conflito-card-field-value">
                                            Data Fim: <span>{{ rowData.dataFim }}</span>
                                        </span>
                                    </div>
                                }
                            </div>
                        </app-card-container>
                    </ng-template>
                </app-custom-table>
            </app-tab-content>
        </app-tab-container>
    </app-card-content>
}

@if (mostrandoFormulario()) {
    <app-card-content [border]="false" [headerColor]="true" icon="pi pi-building" title="Dados do Cadastro">
        <div card-header class="flex items-center gap-2">
            <p-button icon="pi pi-arrow-left" [text]="true" [rounded]="true" size="small" (onClick)="fecharDialogConflito()" pTooltip="Voltar" tooltipPosition="left" />
            @if ((registrosConflito().length > 0 || modoEdicao()) && abaSelecionada() === 'ATIVAS') {
                @if (!modoEdicao()) {
                    <app-botao-acoes [label]="'Ações'" [items]="acoesFormulario" [appCan]="roleConflitoEditar" [appCanUf]="pessoa()?.uf" />
                }
            }
        </div>

        <form [formGroup]="conflitoInteresseForm">
            <div class="flex flex-col gap-4">
                <!-- Dados principais -->
                <app-card-content [headerColor]="false" icon="pi pi-id-card" title="Dados do Cadastro">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="field">
                            <label for="cnpj" class="font-semibold block mb-2">CNPJ</label>
                            <p-inputmask
                                id="cnpj"
                                formControlName="cnpj"
                                mask="99.999.999/9999-99"
                                placeholder="00.000.000/0000-00"
                                [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                                [disabled]="!modoEdicao()"
                                [attr.aria-invalid]="campoInvalido('cnpj') ? true : null"
                                [attr.aria-describedby]="campoInvalido('cnpj') ? 'erro-cnpj' : null"
                            />
                            @if (campoInvalido('cnpj')) {
                                <small class="erro-campo" id="erro-cnpj">{{ mensagemErroCampo('cnpj') }}</small>
                            }
                        </div>

                        <div class="field">
                            <label for="razaoSocial" class="font-semibold block mb-2">Razão Social</label>
                            <input
                                pInputText
                                id="razaoSocial"
                                formControlName="razaoSocial"
                                placeholder="Digite a razão social"
                                [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                                [disabled]="!modoEdicao()"
                                [attr.aria-invalid]="campoInvalido('razaoSocial') ? true : null"
                                [attr.aria-describedby]="campoInvalido('razaoSocial') ? 'erro-razaoSocial' : null"
                            />
                            @if (campoInvalido('razaoSocial')) {
                                <small class="erro-campo" id="erro-razaoSocial">{{ mensagemErroCampo('razaoSocial') }}</small>
                            }
                        </div>
                    </div>
                </app-card-content>

                <!-- Natureza do Vínculo -->
                <app-card-content [headerColor]="false" icon="pi pi-link" title="Natureza do Vínculo">
                    <div class="field">
                        <label for="naturezaVinculo" class="font-semibold block mb-2">Natureza do Vínculo</label>
                        <p-select
                            [appendTo]="'body'"
                            id="naturezaVinculo"
                            formControlName="naturezaVinculo"
                            [options]="opcoesNaturezaVinculo()"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Selecione"
                            [styleClass]="!modoEdicao() ? 'w-full readonly-input natureza-vinculo-select' : 'w-full natureza-vinculo-select'"
                            panelStyleClass="natureza-vinculo-panel"
                            [disabled]="!modoEdicao() || loadingNaturezas()"
                            [attr.aria-invalid]="campoInvalido('naturezaVinculo') ? true : null"
                            [attr.aria-describedby]="campoInvalido('naturezaVinculo') ? 'erro-naturezaVinculo' : null"
                        />
                        @if (campoInvalido('naturezaVinculo')) {
                            <small class="erro-campo" id="erro-naturezaVinculo">{{ mensagemErroCampo('naturezaVinculo') }}</small>
                        }
                        @if (loadingNaturezas()) {
                            <small class="text-color-secondary">Carregando naturezas de vínculo...</small>
                        }
                        @if (!loadingNaturezas() && erroNaturezas()) {
                            <small class="text-red-500">{{ erroNaturezas() }}</small>
                        }
                    </div>
                </app-card-content>

                <!-- Contato -->
                <app-card-content [headerColor]="false" icon="pi pi-address-book" title="Contato">
                    <div class="field">
                        <label for="emailEmpresa" class="font-semibold block mb-2">E-mail</label>
                        <input
                            pInputText
                            id="emailEmpresa"
                            type="email"
                            formControlName="emailEmpresa"
                            placeholder="email@empresa.com"
                            [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                            [disabled]="!modoEdicao()"
                            [attr.aria-invalid]="campoInvalido('emailEmpresa') ? true : null"
                            [attr.aria-describedby]="campoInvalido('emailEmpresa') ? 'erro-emailEmpresa' : null"
                        />
                        @if (campoInvalido('emailEmpresa')) {
                            <small class="erro-campo" id="erro-emailEmpresa">{{ mensagemErroCampo('emailEmpresa') }}</small>
                        }
                    </div>
                </app-card-content>

                <!-- Período -->
                <app-card-content [headerColor]="false" icon="pi pi-calendar" title="Período">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="field">
                            <label for="dataInicio" class="font-semibold block mb-2">Data Início</label>
                            <p-inputmask
                                id="dataInicio"
                                formControlName="dataInicio"
                                mask="99/99/9999"
                                placeholder="DD/MM/AAAA"
                                [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                                [disabled]="!modoEdicao()"
                                [attr.aria-invalid]="campoInvalido('dataInicio') ? true : null"
                                [attr.aria-describedby]="campoInvalido('dataInicio') ? 'erro-dataInicio' : null"
                            />
                            @if (campoInvalido('dataInicio')) {
                                <small class="erro-campo" id="erro-dataInicio">{{ mensagemErroCampo('dataInicio') }}</small>
                            }
                        </div>
                        <div class="field">
                            <label for="dataFim" class="font-semibold block mb-2">Data Fim</label>
                            <p-inputmask
                                id="dataFim"
                                formControlName="dataFim"
                                mask="99/99/9999"
                                placeholder="DD/MM/AAAA"
                                [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                                [disabled]="!modoEdicao()"
                                [attr.aria-invalid]="campoInvalido('dataFim') ? true : null"
                                [attr.aria-describedby]="campoInvalido('dataFim') ? 'erro-dataFim' : null"
                            />
                            @if (campoInvalido('dataFim')) {
                                <small class="erro-campo" id="erro-dataFim">{{ mensagemErroCampo('dataFim') }}</small>
                            }
                        </div>
                    </div>
                </app-card-content>
            </div>

            @if (modoEdicao() && abaSelecionada() === 'ATIVAS') {
                <div class="flex justify-end gap-2 mt-4">
                    <p-button label="Cancelar" icon="pi pi-times" [text]="true" (onClick)="cancelarEdicao()"></p-button>
                    <p-button label="Salvar" icon="pi pi-check" (onClick)="salvarDados()" [disabled]="conflitoInteresseForm.invalid || saving()" [appCan]="roleConflitoEditar" [appCanUf]="pessoa()?.uf"></p-button>
                </div>
            }
        </form>
    </app-card-content>
}
